import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'signs_rule_simple'
})


function question (q, a, b) {

    let result = a * b

    let s = (a < 0 ? '(' + a + ')' : a) +
            'xx' +
            (b < 0 ? '(' + b + ')' : b)


    q.addMathFormula(s)

    q.answer = [
        result,
        q.evalAnswer(result)
    ]

}


level.addQuestion({
    generator: function (q) {
        question(
            q,
            random.fairChoice([1, 2, 3],  {name: 'a'}),
            -random.fairChoice([1, 2, 3], {name: 'b'})
        )
    }
})



level.addQuestion({
    generator: function (q) {
        question(
            q,
            -random.fairChoice([1, 2, 3], {name: 'a'}),
            -random.fairChoice([1, 2, 3], {name: 'b'})
        )
    }
})


level.addQuestion({
    generator: function (q) {
        question(
            q,
            -random.fairChoice([1, 2, 3], {name: 'a'}),
            random.fairChoice([1, 2, 3],  {name: 'b'})
        )
    }
})


level.addQuestion({
    generator: function (q) {
        question(
            q,
            random.fairChoice([-3, -2, -1, 1, 2, 3], {name: 'a'}),
            random.fairChoice([-3, -2, -1, 1, 2, 3], {name: 'b'})
        )
    },
    times: 2
})


export default level


